import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";
import * as moment_ from 'moment';
const moment = moment_;

@Pipe({
  name: "readableTime"
})
export class ReadableTimePipe implements PipeTransform {
  transform(time: string, locale: string): any {
    locale = locale || "en";
    const m = moment(time).locale(locale);
    if (m.isValid()) {
      return m.fromNow();
    }
    return "";
  }
}
